module.exports = __webpack_public_path__ + "static/media/ale-baja-logo-three-colors.0822adf7.svg";